import Vue from 'vue'

const state = {
    search: '',
    selected_areas: 'all',
    selected_categories: 'all',
    selected_groups: '',
    selected_tags: [],
    selected_extensions: []
}

const actions = {
    SET_FILTERS(context, [search, selected_areas, selected_categories, selected_groups, selected_tags, selected_extensions]) {
        context.commit('SAVE_FILTERS', [search, selected_areas, selected_categories, selected_groups, selected_tags, selected_extensions])
    },

    SET_FILTERS_SEARCH(context, [search]) {
        context.commit('SAVE_FILTERS_SEARCH', [search])
    }
}

const mutations = {
    SAVE_FILTERS: (state, [search, selected_areas, selected_categories, selected_groups, selected_tags, selected_extensions]) => {
        Vue.set(state, 'search', search)
        Vue.set(state, 'selected_areas', selected_areas)
        Vue.set(state, 'selected_categories', selected_categories)
        Vue.set(state, 'selected_groups', selected_groups)
        Vue.set(state, 'selected_tags', selected_tags)
        Vue.set(state, 'selected_extensions', selected_extensions)
    },

    SAVE_FILTERS_SEARCH: (state, [search]) => {
        Vue.set(state, 'search', search)
    }
}

const getters = {
    search: state => {
        return state.search
    },

    selected_areas: state => {
        return state.selected_areas
    },

    selected_categories: state => {
        return state.selected_categories
    },

    selected_groups: state => {
        return state.selected_groups
    },

    selected_tags: state => {
        return state.selected_tags
    },

    selected_extensions: state => {
        return state.selected_extensions
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}